import React, { Component } from "react";

import {
  CCard,
  CCardHeader,
  CCardBody,
  CFormGroup,
  CInputGroup,
  CInputGroupPrepend,
  CInputGroupText,
  CSpinner,
  CButton,
  CLabel,
  CSelect
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Prompt } from "react-router-dom";
import { bindActionCreators } from "redux";
import { change as changeFormField } from "redux-form";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Form from "../../../../components/Forms/Form";
import {
  alphaNumeric,
  required
} from "../../../../components/Forms/validators";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import Uploader from "../../../../components/Uploader/uploader";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import estados from "../../../../utils/_estados";
import municipios from "../../../../utils/_municipios";

const UF_TO_IBGE = {
  RO: 11,
  AC: 12,
  AM: 13,
  RR: 14,
  PA: 15,
  AP: 16,
  TO: 17,
  MA: 21,
  PI: 22,
  CE: 23,
  RN: 24,
  PB: 25,
  PE: 26,
  AL: 27,
  SE: 28,
  BA: 29,
  MG: 31,
  ES: 32,
  RJ: 33,
  SP: 35,
  PR: 41,
  SC: 42,
  RS: 43,
  MS: 50,
  MT: 51,
  GO: 52,
  DF: 53
};

const normalizeText = text =>
  (text || "").normalize("NFD").replace(/[̀-ͯ]/g, "").trim().toLowerCase();

class SchoolCreate extends Component {
  constructor(props) {
    super(props);

    this.state = {
      school: {},
      edit: false,
      // user: {},
      optionsGroup: [{ value: null, name: "Carregando" }],
      optionsRegion: [{ value: null, name: "Carregando" }],
      group_id: null,
      region_id: null,
      state: null,
      city: null,
      google: false,
      // district: "",
      loading: true,
      image: null,
      fase: 1,
      creating: true,
      fases: 3,
      submitButton: false
    };

    this.formRef = React.createRef();
    this.error = this.error.bind(this);
    this.fieldsMount = this.fieldsMount.bind(this);
    this.fieldsMount2 = this.fieldsMount2.bind(this);
    this.fieldsMount3 = this.fieldsMount3.bind(this);
    this.enviar = this.enviar.bind(this);
    this.atualizar = this.atualizar.bind(this);
    this.validator = this.validator.bind(this);
    this.handleCepResolved = this.handleCepResolved.bind(this);
  }

  handleCepResolved(address) {
    if (!address) {
      toastr.error("CEP", "CEP não encontrado");
      return;
    }

    this.props.changeFormField("formBase", "address", address.street);
    this.props.changeFormField("formBase", "district", address.neighborhood);

    const stateCode = UF_TO_IBGE[address.state];
    const municipio = municipios.municipios.find(
      m =>
        m.reference === stateCode &&
        normalizeText(m.label) === normalizeText(address.city)
    );

    this.setState(prevState => ({
      state: stateCode || prevState.state,
      city: municipio ? municipio.value : prevState.city
    }));
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  validator(validator) {
    for (let i = 0; i < validator.length; i++) {
      if (!validator[i].value) {
        toastr.error("Erro", `Favor preencher o campo ${validator[i].label}`);
        return false;
      }
    }

    return true;
  }

  componentDidMount() {
    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);
    this.setState({ creating: true });

    axios
      .get(`${URL.api}access/group/list`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        respGroup => {
          const optionsGroup = [];
          respGroup.data.data.forEach(group => {
            optionsGroup.push({ value: group.id, name: group.name });
          });

          this.setState({ optionsGroup });
        },
        error => {
          this.error("Não foi possível listar os grupos");
        }
      );

    const { id } = this.props.match.params;

    this.setState(
      () => ({
        loading: true
      }),
      () => {
        axios
          .get(`${URL.api}access/region/list`, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(
            respregion => {
              axios
                .get(`${URL.api}access/role/list`, {
                  headers: { authorization: `Bearer ${this.props.user.token}` }
                })
                .then(
                  resprole => {
                    axios
                      .get(`${URL.api}configuration/social/list`, {
                        headers: {
                          authorization: `Bearer ${this.props.user.token}`
                        }
                      })
                      .then(
                        respsocial => {
                          let fieldsArray1 = this.fieldsMount(
                            respregion.data.data
                          );
                          let fieldsArray2 = this.fieldsMount2(
                            resprole.data.data
                          );
                          let fieldsArray3 = this.fieldsMount3(
                            respsocial.data.data
                          );

                          this.setState(
                            () => {
                              const optionsRegion = [];

                              respregion.data.data.forEach(region => {
                                optionsRegion.push({
                                  value: region.id,
                                  name: region.name,
                                  group_id: region.group_id
                                });
                              });

                              return {
                                optionsRegion,
                                fields1: fieldsArray1,
                                fields2: fieldsArray2,
                                fields3: fieldsArray3,
                                social: respsocial.data.data
                              };
                            },
                            () => {
                              if (!id) {
                                this.setState(() => ({
                                  group_id:
                                    this.props.general.active_roles.group_id,
                                  region_id:
                                    this.props.general.active_roles.region_id,
                                  loading: false
                                }));
                              } else {
                                axios
                                  .get(
                                    `${URL.api}access/school/singleView/${id}`,
                                    {
                                      headers: {
                                        authorization: `Bearer ${this.props.user.token}`
                                      }
                                    }
                                  )
                                  .then(
                                    resp => {
                                      let schoolContact = {};
                                      schoolContact = {
                                        contact_name:
                                          resp.data.data.contact[0]?.name,
                                        phone1:
                                          resp.data.data.contact[0]?.phone1,
                                        phone2:
                                          resp.data.data.contact[0]?.phone2,
                                        role_id: resp.data.data.contact[0]?.role
                                      };

                                      let schoolSocial = {};
                                      for (
                                        let i = 0;
                                        i < resp.data.data.social.length;
                                        i++
                                      ) {
                                        for (
                                          let j = 0;
                                          j < this.state.social.length;
                                          j++
                                        ) {
                                          if (
                                            resp.data.data.social[i]
                                              .social_id ===
                                            this.state.social[j].id
                                          ) {
                                            schoolSocial[
                                              this.state.social[j].name
                                            ] = resp.data.data.social[i].link;
                                            schoolSocial[
                                              `social_${this.state.social[j].name}_code`
                                            ] = resp.data.data.social[i].code;
                                            break;
                                          }
                                        }
                                      }
                                      let school = Object.assign(
                                        resp.data.data.school,
                                        schoolContact,
                                        schoolSocial
                                      );

                                      this.setState(
                                        () => ({
                                          group_id: school.group_id,
                                          region_id: school.region_id,
                                          city: parseInt(school.city),
                                          state: parseInt(school.state),
                                          school,
                                          google: school.google
                                        }),
                                        () => {
                                          this.setState(() => ({
                                            edit: true,
                                            loading: false
                                          }));
                                        }
                                      );
                                    },
                                    error => {
                                      this.error(
                                        "Não foi possível obter informações da escola"
                                      );
                                    }
                                  );
                              }
                            }
                          );
                        },
                        error => {
                          this.error(
                            "Não foi possível listar as mídias sociais"
                          );
                        }
                      );
                  },
                  error => {
                    this.error("Não foi possível listar os perfis");
                  }
                );
            },
            error => {
              this.error("Não foi possível listar as regionais");
            }
          );
      }
    );
  }

  fieldsMount(region) {
    let optionsRegion = [];
    for (let i = 0; i < region.length; i++) {
      let obj = {
        value: region[i].id,
        name: region[i].name
      };

      optionsRegion[i] = obj;
    }

    let Fields = [
      {
        name: "name",
        label: "Nome",
        type: "text",
        required: true,
        icon: "fa fa-university",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "url",
        label: "Site",
        type: "text",
        required: false,
        icon: "fa fa-link",
        value: "",
        validate: []
      },
      {
        name: "external_id",
        label: "ID externo",
        type: "text",
        required: false,
        icon: "fa fa-text-width",
        value: "",
        validate: [alphaNumeric]
      },
      {
        name: "postal_code",
        label: "Código postal",
        type: "cep",
        required: true,
        icon: "fa fa-envelope",
        value: "",
        validate: [required, alphaNumeric],
        onCepResolved: this.handleCepResolved
      },
      {
        name: "address",
        label: "Endereço",
        type: "text",
        required: true,
        icon: "fa fa-address-book",
        value: "",
        validate: [required]
      },
      {
        name: "complement",
        label: "Complemento",
        type: "text",
        required: false,
        icon: "fa fa-address-book",
        value: "",
        validate: []
      },
      {
        name: "district",
        label: "Bairro",
        type: "text",
        required: true,
        icon: "fa fa-text-width",
        value: "",
        validate: [required, alphaNumeric]
      }
    ];

    return Fields;
  }

  fieldsMount2(role) {
    let optionsRole = [];
    for (let i = 0; i < role.length; i++) {
      let obj = {
        value: role[i].id,
        name: role[i].name
      };

      optionsRole[i] = obj;
    }

    let Fields = [
      {
        name: "contact_name",
        label: "Nome do contato",
        type: "text",
        required: true,
        icon: "fa fa-user",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "phone1",
        label: "Telefone do contato",
        type: "phone",
        required: true,
        icon: "fa fa-phone",
        value: "",
        validate: [required, alphaNumeric]
      },
      {
        name: "phone2",
        label: "Telefone do contato",
        type: "phone",
        required: true,
        icon: "fa fa-phone",
        value: "",
        validate: [alphaNumeric]
      },
      {
        name: "role_id",
        label: "Perfil",
        type: "select",
        required: true,
        options: optionsRole,
        icon: "fa fa-user",
        value: "",
        validate: [required, alphaNumeric]
      }
    ];

    return Fields;
  }

  fieldsMount3(social) {
    let Fields = [];
    for (let i = 0; i < social.length; i++) {
      let obj = {
        name: social[i].name,
        label: social[i].name,
        type: "text",
        required: true,
        icon: social[i].icon,
        validate: []
      };
      Fields.push(obj);

      let obj2 = {
        name: `social_${social[i].name}_code`,
        label: `Código ${social[i].name}`,
        type: "text",
        required: true,
        icon: social[i].icon,
        validate: []
      };
      Fields.push(obj2);
    }

    return Fields;
  }

  enviar(value) {
    this.setState({ creating: true, submitButton: true });

    let validator = [];

    if (this.validator(validator)) {
      let obj = {
        loggedUser: this.props.user.user.id,
        name: value.name,
        region_id: this.state.region_id,
        address: value.address,
        complement: value.complement,
        state: this.state.state,
        city: this.state.city,
        district: value.district,
        postal_code: value.postal_code,
        geolocation: value.geolocation,
        url: value.url,
        image: this.state.image,
        external_id: value.external_id,
        google: this.state.google
      };

      if (!obj.district) {
        obj.district = "";
      }
      if (!obj.geolocation) {
        obj.geolocation = "";
      }
      if (!obj.url) {
        obj.url = "";
      }
      if (!obj.external_id) {
        obj.external_id = "";
      }

      validator[0] = { value: obj.name, label: "Nome" };
      validator[1] = { value: obj.region_id, label: "Região" };
      validator[2] = { value: obj.address, label: "Endereço" };
      validator[3] = { value: obj.postal_code, label: "CEP" };
      if (this.validator(validator)) {
        axios
          .post(`${URL.api}access/school/insert`, obj, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(
            resp => {
              this.props.history.push("/school/list");
              this.setState({ creating: false, submitButton: false });
            },
            error => {
              this.error("Não foi possível inserir a escola");
              this.setState({ creating: false, submitButton: false });
            }
          );
      }
    }
  }

  atualizar(value) {
    this.setState({ creating: true, submitButton: true });

    let validator = [];
    if (this.validator(validator)) {
      let obj = {
        loggedUser: this.props.user.user.id,
        name: value.name,
        region_id: this.state.region_id,
        address: value.address,
        complement: value.complement,
        state: this.state.state,
        city: this.state.city,
        district: value.district,
        postal_code: value.postal_code,
        geolocation: value.geolocation,
        url: value.url,
        image: this.state.image,
        external_id: value.external_id,
        google: this.state.google
      };

      if (!obj.district) {
        obj.district = "";
      }
      if (!obj.geolocation) {
        obj.geolocation = "";
      }
      if (!obj.url) {
        obj.url = "";
      }
      if (!obj.external_id) {
        obj.external_id = "";
      }

      validator[0] = { value: obj.name, label: "Nome" };
      validator[1] = { value: obj.region_id, label: "Região" };
      validator[2] = { value: obj.address, label: "Endereço" };
      validator[3] = { value: obj.postal_code, label: "CEP" };
      if (this.validator(validator)) {
        axios
          .post(`${URL.api}access/school/update/ ${value.id}`, obj, {
            headers: { authorization: `Bearer ${this.props.user.token}` }
          })
          .then(
            resp => {
              this.props.history.push("/school/list");
              this.setState({ creating: false, submitButton: false });
            },
            error => {
              this.error("Não foi possível editar a escola");
              this.setState({ creating: false, submitButton: false });
            }
          );
      }
    }
  }

  getAtualFase = fase => {
    this.setState({
      fase
    });
  };

  previous() {
    this.setState(state => ({
      fase: Math.max(1, state.fase - 1)
    }));
  }

  next() {
    this.setState(state => ({
      fase: Math.min(state.fases, state.fase + 1)
    }));
  }

  done(uploads) {
    this.setState(() => ({
      image: uploads[0]
    }));
  }

  render() {
    return (
      <React.Fragment>
        <Prompt
          when={!this.state.creating}
          message="Os dados do formulário ainda não foram salvos. Tem certeza de que deseja sair desta página?"
        />
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/school/list", to: "/school/list" }]}
        />
        {this.state.loading ? (
          <Loading />
        ) : (
          <CCard>
            <CCardHeader className="d-flex align-items-center">
              <div
                style={{ display: "flex", flexDirection: "column", flex: 1 }}
              >
                <h4 className="card-title mb-1">
                  {this.state.edit ? "Editar Escola" : "Criar Escola"}
                </h4>
                <div className="small text-muted">
                  {this.state.edit
                    ? "Edite a escola selecionada"
                    : "Crie uma nova escola"}
                </div>
              </div>
              <CButton
                color="primary"
                className="d-flex justify-content-center align-items-center"
                onClick={() => this.formRef.current.submit()}
                disabled={!this.state.creating}
              >
                <>
                  <span style={this.state.submitButton ? { opacity: 0 } : null}>
                    <i className="fa fa-cloud-upload mr-2"></i>Salvar
                  </span>
                  {this.state.submitButton && (
                    <CSpinner
                      size="sm"
                      color="white"
                      style={{ position: "absolute" }}
                    />
                  )}
                </>
              </CButton>
            </CCardHeader>
            <CCardBody>
              <div>
                <Uploader
                  type="school"
                  maxFiles={1}
                  allowMultiple
                  labelIdle='Arraste e solte seu arquivo ou <span class="filepond--label-action">procure</span>'
                  done={uploads => this.done(uploads)}
                />
                <Form
                  avatar
                  fields={this.state.fields1}
                  ref={this.formRef}
                  history={this.props.history}
                  onSubmit={this.state.edit ? this.atualizar : this.enviar}
                  initialValues={this.state.school}
                  edit={this.state.edit}
                />
                <CFormGroup>
                  <CLabel>Estado</CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-map-marker"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CSelect
                      className="flex-1"
                      value={this.state.state}
                      onChange={e =>
                        this.setState({
                          state: parseInt(e.target.value),
                          city: null
                        })
                      }
                    >
                      <option value={null}>Estado</option>
                      {estados.estados.map(estado => (
                        <option value={estado.value}>{estado.label}</option>
                      ))}
                    </CSelect>
                  </CInputGroup>
                </CFormGroup>
                <CFormGroup>
                  <CLabel>Cidade</CLabel>
                  <CInputGroup>
                    <CInputGroupPrepend>
                      <CInputGroupText>
                        <i className="fa fa-map-marker"></i>
                      </CInputGroupText>
                    </CInputGroupPrepend>
                    <CSelect
                      className="flex-1"
                      value={this.state.city}
                      onChange={e =>
                        this.setState({ city: parseInt(e.target.value) })
                      }
                    >
                      <option value={null}>Cidade</option>
                      {municipios.municipios
                        .filter(
                          municipio => municipio.reference === this.state.state
                        )
                        .map(municipio => (
                          <option value={municipio.value}>
                            {municipio.label}
                          </option>
                        ))}
                    </CSelect>
                  </CInputGroup>
                </CFormGroup>
                {["G"].includes(this.props.general.active_roles.type) && (
                  <CFormGroup>
                    <CLabel>Grupo</CLabel>
                    <CInputGroup>
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-group"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CSelect
                        className="flex-1"
                        value={this.state.group_id}
                        onChange={e =>
                          this.setState({
                            group_id: parseInt(e.target.value),
                            region_id: null
                            // school_id: null
                          })
                        }
                        disabled={
                          this.props.general.active_roles.group_id !== null
                        }
                      >
                        <option value={null}>Grupo</option>
                        {this.state.optionsGroup.map(group => (
                          <option value={group.value}>{group.name}</option>
                        ))}
                      </CSelect>
                    </CInputGroup>
                  </CFormGroup>
                )}
                {["G", "U"].includes(this.props.general.active_roles.type) && (
                  <CFormGroup>
                    <CLabel>Regional</CLabel>
                    <CInputGroup>
                      <CInputGroupPrepend>
                        <CInputGroupText>
                          <i className="fa fa-group"></i>
                        </CInputGroupText>
                      </CInputGroupPrepend>
                      <CSelect
                        className="flex-1"
                        value={this.state.region_id}
                        onChange={e =>
                          this.setState({
                            region_id: parseInt(e.target.value)
                            // school_id: null
                          })
                        }
                        disabled={
                          this.props.general.active_roles.region_id !== null
                        }
                      >
                        <option value={null}>Regional</option>
                        {this.state.optionsRegion
                          .filter(
                            region => region.group_id === this.state.group_id
                          )
                          .map(region => (
                            <option value={region.value}>{region.name}</option>
                          ))}
                      </CSelect>
                    </CInputGroup>
                  </CFormGroup>
                )}
                {/* <CFormGroup>
                  <CLabel>Serviços Google</CLabel>
                  <CInputGroup>
                    <CSwitch color="primary" shape="pill" size="sm" checked={this.state.google} onChange={(e) => this.setState({ google: e.target.checked })} />
                  </CInputGroup>
                </CFormGroup> */}
              </div>
            </CCardBody>
          </CCard>
        )}
        <ProtectedRoute routeId={this.props.currentRoute} />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj,
      changeFormField
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(SchoolCreate);
